import { useTranslation } from "react-i18next";

import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import GetAppIcon from "@mui/icons-material/GetApp";
import QrCode2Icon from "@mui/icons-material/QrCode2";
import { useSnackbar } from "notistack";

import Button from "../../components/Button";
import { getSSID, fetchAndDownloadFile } from "../../api";
import orderStatusService from "../../services/orderStatus";
import paymentTypeService, { hasQrBill } from "../../services/paymentType";

async function downloadInvoiceFile(filename, onNotFound) {
  const ssid = await getSSID();
  const url = `${process.env.REACT_APP_API_URL}/files/download/invoice/${filename}?ssid=${ssid}`;
  await fetchAndDownloadFile(url, onNotFound);
}

function formatDate(string) {
  return new Date(string).toLocaleString("de-CH");
}

const OrderItem = ({ order }) => {
  const { t } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();

  const handleNotFound = () => enqueueSnackbar(t("orders.document_not_found"), { variant: "error" });

  const downloadOrder = (filename) => downloadInvoiceFile(filename, handleNotFound);

  const downloadQRCode = (filename) => {
    const qrCodeFilename = filename.replace("Invoice_NGFT_", "Invoice_NGFT_QR_");
    return downloadInvoiceFile(qrCodeFilename, handleNotFound);
  };

  return (
    <TableRow key={order.order_id}>
      <TableCell>{order.order_id}</TableCell>
      <TableCell>{order.buyer}</TableCell>
      <TableCell>{formatDate(order.created_at)}</TableCell>
      <TableCell>
        {order.items.map((d, index) => (
          <li key={`${order.order_id}-${index}`}>
            ({d.course_id}) {d.course_name} - {d.user_name}
          </li>
        ))}
      </TableCell>
      <TableCell>{paymentTypeService.getByCode(order.payment_type)?.getDisplayName(t) || order.payment_type}</TableCell>
      <TableCell>{order.total}</TableCell>
      <TableCell>{orderStatusService.getByCode(order.status)?.getDisplayName(t) || order.status}</TableCell>
      <TableCell>
        <Button
          title={t("orders.download_invoice")}
          icon={<GetAppIcon />}
          onClick={() => downloadOrder(order.invoice_name)}
        />
        {hasQrBill(order.payment_type) && (
          <Button
            title={t("orders.download_qr_code")}
            icon={<QrCode2Icon />}
            onClick={() => downloadQRCode(order.invoice_name)}
          />
        )}
      </TableCell>
    </TableRow>
  );
};

export default OrderItem;
